import { PROVISIONING_I18N_PREFIX } from '@/console/features/orchestrators/orchestrators.constants';
import { TStatusChipDescriptor } from '@/console/features/orchestrators/utils/provisioning-status.types';
import { ChipStatus } from '@/shared/components/ui/chip/chip.types';

const ORCHESTRATOR_ACTIVE = 'active';

export const isOrchestratorActive = (status?: string | null) =>
  status === ORCHESTRATOR_ACTIVE;

// An install in progress reports offline with no agent version, for minutes. An
// active heartbeat outranks a missing version: the agent is up, whatever the listing lost.
export const isOrchestratorSettingUp = (
  status?: string | null,
  agentVersion?: string | null,
) => !agentVersion && !isOrchestratorActive(status);

// Autonomy declare no schema here: anything not 'active' is unreachable.
export const getOrchestratorStatusDescriptor = (
  status?: string | null,
  agentVersion?: string | null,
): TStatusChipDescriptor => {
  if (isOrchestratorSettingUp(status, agentVersion)) {
    return {
      chipStatus: 'blue',
      labelKey: `${PROVISIONING_I18N_PREFIX}.setting_up`,
      labelFallback: '',
    };
  }

  if (!status) {
    return {
      chipStatus: 'red',
      labelKey: 'common:unknown',
      labelFallback: '',
    };
  }

  const chipStatus: ChipStatus = isOrchestratorActive(status) ? 'green' : 'red';

  return {
    chipStatus,
    labelKey: `${PROVISIONING_I18N_PREFIX}.orchestrator_status.${status}`,
    labelFallback: status,
  };
};
